import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export const userSlices = createSlice({
  name: "user",
  initialState: { loggedStatus: false, name: "", email: "" },
  reducers: {
    login: (state, actions: PayloadAction<{ name: string; email: string }>) => {
      state.loggedStatus = true;
      state.name = actions.payload.name;
      state.email = actions.payload.email;
    },
    logout: (state) => {
      state.loggedStatus = false;
    },
  },
});

export const { login, logout } = userSlices.actions;

export const userReducer = userSlices.reducer;
